import { useCallback } from "react";

import {
    useBaseIdentityAttrs,
    useFireAnalyticsEvents
} from "@/components/fastshift/analytics";
import {
    SourceKey,
    ActionKey,
    ActionSubjectKey,
    ActionSubjectIdKey
} from "@/components/fastshift/analytics/constants";

export const useCustomerSelectionUIAnalytics = () => {
    const identityAttrs = useBaseIdentityAttrs();
    const { fireUIEvent } = useFireAnalyticsEvents(identityAttrs);

    // UI event callbacks
    const sendSeeDetailsClickUIEvent = useCallback(
        (selectedCustomerDomain: string, selectedCustomerDomainId: string) => {
            fireUIEvent({
                action: ActionKey.CLICKED,
                actionSubject: ActionSubjectKey.LINK,
                actionSubjectId: ActionSubjectIdKey.SEE_DETAILS_BUTTON,
                source: SourceKey.FASTSHIFT_PORTAL_SELECTION_SCREEN,
                attributes: {
                    selectedCustomerDomain,
                    selectedCustomerDomainId
                }
            });
        },
        [fireUIEvent]
    );

    return {
        sendSeeDetailsClickUIEvent
    };
};
